import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

// const Product = lazy(() => import('../../pages/events/product/Products'));
// const ProductDetails = lazy(() => import('../../pages/events/product/ProductDetails'));
// const Invoice = lazy(() => import('../../pages/events/Invoice'));
// const Sellers = lazy(() => import('../../pages/events/Sellers'));
// const Cart = lazy(() => import('../../pages/events/Cart'));
const EventAdd = lazy(() => import('../../pages/event-management/events/EventAdd'));
const EventEdit = lazy(() => import('../../pages/event-management/events/EventEdit'));
const Events = lazy(() => import('../../pages/event-management/events/EventsList'));
const EventRegistrations = lazy(() => import('../../pages/event-management/events/EventRegistrations'));
const QrAttendance = lazy(() => import('../../pages/event-management/qr-attendance'));

function EventsRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/events/add`} component={EventAdd} />
            <Route exact path={`${path}/events`} component={Events} />
            <Route exact path={`${path}/events/edit/:id`} component={EventEdit} />
            <Route exact path={`${path}/events/registrations/:id`} component={EventRegistrations} />
            <Route exact path={`${path}/qr-attendance`} component={QrAttendance} />
            {/* <Route path={`${path}/products`} component={Product} />
      <Route exact path={`${path}/edit-product`} component={ProductEdit} />
      <Route exact path={`${path}/productDetails/:id`} component={ProductDetails} />
      <Route exact path={`${path}/invoice`} component={Invoice} />
      <Route exact path={`${path}/sellers`} component={Sellers} />
      <Route path={`${path}/cart`} component={Cart} /> */}
        </Switch>
    );
}

export default EventsRoute;
